import React from 'react';
import axios from 'axios';
import { Button, Card, Descriptions } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { StatsApi } from '../../../services/Api';

interface PanelRecordProps {
    trans: (key: string) => string;
}

interface PanelRecordState {
    recordTotal: number | string;
    incrCntToday: number | string;
    incrCntYesterday: number | string;
    incrCntThisWeek: number | string;
    incrCntLastWeek: number | string;
    incrCntThisMonth: number | string;
    incrCntLastMonth: number | string;
    loading: boolean;
}

interface StatsInfo {
    total: number | string;
    incr: {
        incrCntToday: number | string;
        incrCntYesterday: number | string;
        incrCntThisWeek: number | string;
        incrCntLastWeek: number | string;
        incrCntThisMonth: number | string;
        incrCntLastMonth: number | string;
    };
}

export default class PanelRecord extends React.Component<PanelRecordProps, PanelRecordState> {
    state: PanelRecordState = {
        recordTotal: 0,
        incrCntToday: 0,
        incrCntYesterday: 0,
        incrCntThisWeek: 0,
        incrCntLastWeek: 0,
        incrCntThisMonth: 0,
        incrCntLastMonth: 0,
        loading: false,
    };

    updateInfo = (info: StatsInfo) => {
        const DEBUG = true;
        const TAG = 'PanelRecord.updateInfo() - ';
        DEBUG && console.log(TAG, 'info:\n', info);
        this.setState({
            recordTotal: info.total,
            incrCntToday: info.incr.incrCntToday,
            incrCntYesterday: info.incr.incrCntYesterday,
            incrCntThisWeek: info.incr.incrCntThisWeek,
            incrCntLastWeek: info.incr.incrCntLastWeek,
            incrCntThisMonth: info.incr.incrCntThisMonth,
            incrCntLastMonth: info.incr.incrCntLastMonth,
        });
    };

    refreshRecordStats = async () => {
        const DEBUG = true;
        const TAG = 'PanelRecord.refreshRecordStats() - ';
        DEBUG && console.log(TAG, 'CALL refreshRecordStats');

        this.setState({ loading: true });
        try {
            const lang = localStorage.getItem('lang') || 'zh_CN';
            const response = await axios.post(StatsApi.GET_RECORD_INFO, {
                lang: lang.split('_')[0],
            });
            DEBUG && console.log(TAG, response);
            if (response.data?.data) {
                this.updateInfo(response.data.data);
            }
        } finally {
            this.setState({ loading: false });
        }
    };

    render() {
        const { trans: t } = this.props;
        const {
            recordTotal, incrCntToday, incrCntYesterday, incrCntThisWeek,
            incrCntLastWeek, incrCntThisMonth, incrCntLastMonth, loading,
        } = this.state;

        return (
            <Card
                title={t('recordStats')}
                extra={
                    <Button
                        type="text"
                        icon={<ReloadOutlined />}
                        loading={loading}
                        onClick={this.refreshRecordStats}
                    >
                        {t('refresh')}
                    </Button>
                }
            >
                <Descriptions bordered size="small" column={1}>
                    <Descriptions.Item label={t('totalRecordCnt')}>{recordTotal}</Descriptions.Item>
                    <Descriptions.Item label={t('incrCntToday')}>{incrCntToday}</Descriptions.Item>
                    <Descriptions.Item label={t('incrCntYesterday')}>{incrCntYesterday}</Descriptions.Item>
                    <Descriptions.Item label={t('incrCntThisWeek')}>{incrCntThisWeek}</Descriptions.Item>
                    <Descriptions.Item label={t('incrCntLastWeek')}>{incrCntLastWeek}</Descriptions.Item>
                    <Descriptions.Item label={t('incrCntThisMonth')}>{incrCntThisMonth}</Descriptions.Item>
                    <Descriptions.Item label={t('incrCntLastMonth')}>{incrCntLastMonth}</Descriptions.Item>
                </Descriptions>
            </Card>
        );
    }
}
